import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-dashboard-error',
    templateUrl: './dashboard-error.component.html',
    styleUrls: ['./dashboard-error.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardErrorComponent implements OnInit {

  @Input() hasError = false;
  @Input() minHeight = '200px';
  @Input() canReload = true;
  @Output() reload = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

}
